<template>
  <div class="model_continer">
    <p class="dataAnalysisTitle">福安茶叶消费模型预测</p>
    <p
      class="introl"
    >简介：系统采用灰色模型进行预测分析，灰色模型就是通过少量的、不完全的信息，建立灰色微分预测模型，对事物的发展规律作出模糊性的长期描述（模糊预测领域中理论、方法较为完善的预测学分支）。</p>
    <!-- <p class="introl">影响要素：区域、年份、福安茶叶种类、产量、面积、气象等因素</p> -->
    <p class="introl">
      灰度模型公式：
      <span
        style="font-family: serif;"
      >x(0)p(k)=(ba2−x(0)(1)a)(1−ea)e−a(k−1)+ba for k≥2,x(0)p(1)=x(0)(1)</span>
    </p>
    <p class="modelApplyLittleTitle">
      <span>第1步：</span>
      <span>选择预测数据的关键指标字段</span>
    </p>

    <!--本地数据-->
    <label>
      <div class="modelApplyScreen">
        <label>下载模板：</label>
        <a :href="template1">消费模板</a>
      </div>
      <div class="modelApplyScreen">
        <label>预测步长：</label>
        <el-input v-model="step" placeholder="请输入步长"></el-input>
      </div>
      <div class="modelApplyScreen">
        <label>上传数据：</label>
        <el-input v-model="localFileName" placeholder="请选择文件" :readonly="readonly" />
        <span class="screen-upload-btn">
          <input type="file" accept=".xls, .xlsx" @change="uploadFileBtn" class="inputFile" />
          <i class="el-icon-upload2"></i>
          数据上传
        </span>
      </div>
      <div class="modelApplyScreen">
        <label>数据区域：</label>
        <el-select v-model="localProvinceValue" placeholder="选择城市">
          <el-option
            v-for="(item, index) in localProvinceList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <p style="font-size: 12px; width: 50%; color: red">
        <!-- 注意：选择品种最多选择5类胶类进行预测，超出规定数量将不能显示预测效果 -->
      </p>
    </label>

    <p class="modelApplyLittleTitle">
      <span>第2步：</span>
      <span>点击分析查看预测的数据指标</span>
      <el-button class="greenBtn" @click="getForecastBtn">分析</el-button>
    </p>
    <div class="modelApplyTable">
      <el-table :data="areaConsumeList" border style="width: 100%">
        <el-table-column prop="areaName" label="城市"></el-table-column>
        <el-table-column prop="year" label="年份"></el-table-column>
        <el-table-column prop="totalConsumption" label="消费（元）"></el-table-column>
      </el-table>
    </div>
    <div style="clear: both"></div>
    <div id="targetChart" class="targetChart"></div>
  </div>
</template>

<script>
import echarts from "../../utils/js/echartsServer";
import {
  getAreaNameList,
  forecastCostSelect,
  forecastConsume
} from "../../utils/api/consumeForecast";
import {
  localForecastModel,
  uploadFile
} from "../../utils/api/productForecast";
export default {
  name: "ConsumeModel",
  data() {
    return {
      template1: `${this.templateUrl}/消费.xlsx`,
      readonly: true,
      dataSoruce: "history", // 数据来源
      localFileName: "", // 文件名称
      localFileUrl: "", // 文件流
      areaNameList: [], //城市下拉数据
      provinceValue: "", //城市下拉
      step: "", //步长
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示多少条
      total: 0, // 总计数量
      // 表格历史数据
      historyTableData: [],
      areaConsumeList: [], // 第三步预测列表
      localProvinceValue: "", // 本地预测 地区值
      localProvinceList: [], // 本地预测  地区list
      // 数据来源数据
      dataSoruceList: [
        {
          label: "本地数据",
          value: "local"
        },
        {
          label: "历史数据",
          value: "history"
        }
      ]
    };
  },
  methods: {
    // 上传本地文件
    uploadFileBtn(evt) {
      if (!this.step) {
        this.$message({
          message: "请输入预测步长",
          type: "warning"
        });
        return;
      }
      this.localFileName = evt.target.files[0].name;
      this.uploadFile(evt.target.files[0]);
    },
    // 上传文件接口
    async uploadFile(file) {
      let formdata = new FormData();
      formdata.append("file", file);
      let res = await uploadFile(formdata);
      this.localFileUrl = res.data;
      // 根据上传文件 获取地区列表
      this.getAreaListByFile();
    },
    // 数据来源 change   清空查询条件
    dataSoruceChange(value) {
      this.localFileName = ""; // 文件名称清空
      this.localFileUrl = ""; // 文件路径清空\
      this.step = ""; // 步长清空
      this.areaConsumeList = []; // 最后一步预测 列表数据清空
      let yearList = [];
      let realList = [];
      let forecastList = [];
      let echartsData = {
        yearList,
        realList,
        forecastList
      };
      echarts.getTargetChart("targetChart", echartsData);
      // 历史数据 地区默认显示列表第一个
      if (value === "history") {
        this.provinceValue = this.areaNameList[0];
      } else {
        this.localProvinceValue = "";
      }
    },
    //获取图表数据
    async getTargetChartData(yearList, realList, forecastList) {
      let echartsData = {
        yearList,
        realList,
        forecastList
      };
      echarts.getTargetChart("targetChart", echartsData);
    },

    // 获取地区列表
    async getAreaNameList() {
      let res = await getAreaNameList();
      if (res.data.code === 0) {
        this.areaNameList = res.data.data;
        this.provinceValue = this.areaNameList[0]; // 地区默认第一个
        this.forecastCostSelect(); // 第二步预测
      }
    },
    // 城市change
    provinceChage(value) {
      this.provinceValue = value;
    },

    // 第一步预测  分页
    async forecastCostSelect() {
      let params = {
        currentPage: this.currentPage, // 当前页
        pageSize: this.pageSize, // 每页显示多少条
        areaName: this.provinceValue
      };
      let res = await forecastCostSelect(params);
      if (res.data.code === 0) {
        this.historyTableData = res.data.data.records;
        this.total = res.data.data.total;
      }
    },

    // 分页 查询
    currentChange(value) {
      this.currentPage = value;
      this.forecastCostSelect();
    },
    // 消费预测 点击按钮
    getForecastBtn() {
      this.localForecastModel();
    },
    // 历史 消费预测
    async forecastConsume() {
      if (!this.step) {
        this.$message({
          message: "请输入预测步长",
          type: "warning"
        });
        return;
      }
      let params = {
        areaName: this.provinceValue,
        number: this.step
      };
      let res = await forecastConsume(params);
      if (res.data.code === 0) {
        this.areaConsumeList = res.data.data.areaConsumeList;
        this.getTargetChartData(
          res.data.data.yearList,
          res.data.data.realList,
          res.data.data.forecastList
        );
      }
    },

    // 根据上传文件 获取 地区列表
    async getAreaListByFile() {
      let params = {
        file: this.localFileUrl,
        step: this.step
      };
      let res = await localForecastModel(params);
      if (res.data.code === 0) {
        this.localProvinceList = res.data.data.areaList;
      }
    },
    // 本地预测接口
    async localForecastModel() {
      let params = {
        file: this.localFileUrl,
        step: this.step,
        area: this.localProvinceValue
      };
      let res = await localForecastModel(params);
      if (res.data.code === 0) {
        let data = res.data.data;
        // for(let i = 0; i<data.length-1;i++){
        //   for(let j = 0;j<data[i].dataList.length;j++){
        //     this.areaYieldList.push(data[i].dataList[j])
        //   }
        // }
        this.areaConsumeList = data[0].dataList;
        let yearList = [];
        yearList = data[0].yearList;
        let forecastList = [];
        forecastList = data[0].forecastDataList;
        let realList = [];
        realList = data[0].realList;
        let echartsData = {
          yearList,
          forecastList,
          realList,
          unit:'元'
        };
        // let XData = [];
        // XData = res.data.data.yearList;
        // let YData = [];
        // YData1 = res.data.data.realList; // 真实列表
        // YData2 = res.data.data.forecastList; // 预测列表
        // let echartsData = {
        //   XData,
        //   YData1,
        //   YData2
        // };
        echarts.getTargetChart("targetChart", echartsData);
      }
    }
  },
  mounted() {
    // this.getAreaNameList(); // 获取地区
    // this.getTargetChartData();
  }
};
</script>


<style lang="scss" scoped>
.model_continer {
  margin-left: 30px;
}
.introl {
  color: #999;
  font-size: 14px;
  line-height: 22px;
  margin-top: 10px;
}
.modelApplyLittleTitle {
  margin: 20px 0;
}
.modelApplyLittleTitle span:nth-child(1) {
  font-weight: bold;
}
.modelApplyLittleTitle span:nth-child(2) {
  color: #333;
}
.modelApplyScreen {
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 20px;
  label {
    color: #999;
  }
  a {
    color: #333;
    font-size: 14px;
    text-decoration: underline;
  }
}
.greenBtn {
  padding: 6px 12px;
  font-size: 16px;
  letter-spacing: 1px;
  background: #59a6a0;
  border: 1px solid #59a6a0;
  color: #fff;
  margin-left: 30px;
}
.greenBtn:focus,
.greenBtn:hover {
  background: #39a1a6;
  border: 1px solid #39a1a6;
}
.targetChart {
  margin-top: 10px;
  width: 100%;
  height: 400px;
}
.screen-upload-btn {
  width: 100px;
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  font-size: 14px;
  color: #999;
  .inputFile {
    position: absolute;
    width: 100px;
    left: 0px;
    height: 30px;
    opacity: 0;
  }
}
.dataAnalysisTitle {
  font-size: 18px;
}
</style>
